module.exports = __webpack_public_path__ + "static/media/flowers_19.80f95fd5.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_19.csv
// module id = 758
// module chunks = 0